import { Component, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';
import { FormBuilder, FormGroup, FormArray, Validators, AbstractControl, ValidatorFn, ValidationErrors } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { ApiService } from 'app/main/services/Api/api.service';
import { HttpErrorResponse } from '@angular/common/http';
import { ToastService } from 'app/main/services/Toast/toast.service';
import { ColumnMode, DatatableComponent, id } from '@swimlane/ngx-datatable';

@Component({
  selector: 'app-assign-event',
  templateUrl: './assign-event.component.html',
  styleUrls: ['./assign-event.component.scss']
})
export class AssignEventComponent implements OnInit {

  public contentHeader: object;
  eventData: any;
  eventDataLength: number = 0;
  eventId: string = '';

  constructor(
    private router: Router,
    private fb: FormBuilder,
    private api: ApiService,
    public toastService: ToastService,
    private url: ActivatedRoute
  ) {
    // this.initializeForm();
    // this.setupDateValidation();
  }

  ngOnInit(): void {
    this.setupActiveMenuItems();
    this.assgnedOrganizer();
    this.unassgnedOrganizer();

    this.columns = [
      { prop: '#' },
      { prop: 'name', name: 'اسم المشرف' },
      { prop: 'eventName', name: 'اسم الفاعلية' },
      { prop: '' },
    ]

    this.columns2 = [
      { prop: '#' },
      { prop: 'name', name: 'اسم المشرف' },
      { prop: '' },      
    ]
  }

  private setupActiveMenuItems(): void {
    console.log(this.router.url.includes('assign-event'))
    if (this.router.url.includes('assign-event')) {
      const element = document.getElementById('الفعاليات');
      if (element) {
        element.classList.add('active');
      }
      if(this.url.snapshot.params['id']){
        const id = this.url.snapshot.params['id'];
        this.eventId = id;
        this.loadEventData(id);
      }
    } else {
      const itemsToDeactivate = [
        'الرئيسية',
        'المشرفين',
        'المستخدمين',
        'طلبات المشرفين',
        'فئات المناسبات',
        'العروض',
        'المسئولين'
      ];
      
      itemsToDeactivate.forEach(item => {
        const element = document.getElementById(item);
        if (element) {
          element.classList.remove('active');
        }
      });
    }
  }

  assgnedOrganizer(){
    if(this.eventId){
      this.api.getAssignedOrUnAssignedOrganizer(this.eventId,true).subscribe({
        next: (response) => {
          this.assignedOrganizers = response.data.map( (item,index) => ({
            '#': index + 1,
            name: item.nameAr || item.nameEn,
            eventName: this.eventData.nameAr || this.eventData.nameEn,
            id: item.organizerId
          }))
          this.tempAssignedOrganizers = this.assignedOrganizers
        }, error: (error: HttpErrorResponse) => {
          this.toastService.show('حدث خطأ برجاء المحاولة مره اخري ❌');
        }
      });
    }
  }

  unassgnedOrganizer(){
    if(this.eventId){
      this.api.getAssignedOrUnAssignedOrganizer(this.eventId,false).subscribe({
        next: (response) => {
          this.assignNewOrganizers = response.data.map( (item,index) => ({
            '#': index + 1,
            orgName: item.nameAr || item.nameEn,
            id: item.organizerId
          }))
          this.tempAssignNewOrganizers = this.assignNewOrganizers
        }, error: (error: HttpErrorResponse) => {
          this.toastService.show('حدث خطأ برجاء المحاولة مره اخري ❌');
        }
      });
    }
  }

  removeOrganizer(orgId: string){
    if(orgId){
      const payload = {
        organizerId: orgId,
        eventId: this.eventId
      }
      this.api.unAssignEventOfOrganizer(payload).subscribe({
        next: (response) => {
          console.log(response);
          this.toastService.show('تم إضافة المشرف بنجاح ✅');
          this.assgnedOrganizer()
          this.unassgnedOrganizer()
        },error: (error: HttpErrorResponse) => {
          this.toastService.show('حدث خطأ أثناء الإضافة برجاء المحاولة مره اخري ❌');
        }
      });
    }
  }

  addOrganizer(orgId: string){
    if(orgId){
      const payload = {
        organizerId: orgId,
        eventId: this.eventId
      }
      this.api.assignOrganizerToEvent(payload).subscribe({
        next: (response) => {
          console.log(response);
          this.toastService.show('تم إضافة المشرف بنجاح ✅');
          this.assgnedOrganizer()
          this.unassgnedOrganizer()
        },error: (error: HttpErrorResponse) => {
          this.toastService.show('حدث خطأ أثناء الإضافة برجاء المحاولة مره اخري ❌');
        }
      });
    }
  }

  loadEventData(id: string){
    if(id){
      this.api.getEventById(id).subscribe({
        next: (response) => {
          this.eventData = response.data;
          this.eventDataLength = response.data.length;
        },error: (error: HttpErrorResponse) => {
          this.toastService.show('حدث خطأ برجاء المحاولة مره اخري ❌');
        }
      });
    }
  }

  assignOrganizerToEvent(orgID: string){
    if(orgID){
      const payload = {
        eventId: this.eventId,
        organizerId: orgID
      };
      this.api.assignOrganizerToEvent(payload).subscribe({
        next: (response) => {
          console.log(response);
          this.toastService.show('تم تعيين المشرف بنجاح ✅');
          setTimeout(() => {
            window.location.href = '/events';
          }, 2000);
        },error: (error: HttpErrorResponse) => {
          this.toastService.show('حدث خطأ أثناء التعيين برجاء المحاولة مره اخري ❌');
        }
      });
    }
  }

  assignedOrganizers = [];
  tempAssignedOrganizers = [];
  public currentVisible: number = 3;
  public currentPageLimit: number = 10;
  public readonly pageLimitOptions = [
    {value: 5},
    {value: 10},
    {value: 25},
    {value: 50},
    {value: 100},
  ];
  @ViewChild(DatatableComponent) public table: DatatableComponent;
  @ViewChild(DatatableComponent) public table2: DatatableComponent;
  ColumnMode = ColumnMode;
  columns = []
  columns2 = []
  updateFilter(event: any) {
    const val = event?.target?.value ? event.target.value.toLowerCase() : '';
  
    // Filter data by checking all columns
    const temp = this.tempAssignedOrganizers.filter((row) => {
      return Object.keys(row).some((key) => 
        row[key]?.toString().toLowerCase().includes(val)
      );
    });
  
    // Update the rows
    this.assignedOrganizers = temp;
    console.log(temp)
    // Reset to first page
    if (this.table) {
      this.table.offset = 0;
    }
  }
  public onLimitChange(limit: any): void {
    this.changePageLimit(limit);
    this.table.limit = this.currentPageLimit;
    this.table.recalculate();
    setTimeout(() => {
      if (this.table.bodyComponent.temp.length <= 0) {
        // TODO[Dmitry Teplov] find a better way.
        // TODO[Dmitry Teplov] test with server-side paging.
        this.table.offset = Math.floor((this.table.rowCount - 1) / this.table.limit);
        // this.table.offset = 0;
      }
    });
  }
  private changePageLimit(limit: any): void {
    this.currentPageLimit = parseInt(limit, 10);
  }
  public onVisibleChange(visible: any): void {
    this.currentVisible = parseInt(visible, 10);
  }

  assignNewOrganizers = [];
  tempAssignNewOrganizers = [];
  updateFilter2(event: any) {
    const val = event?.target?.value ? event.target.value.toLowerCase() : '';
  
    // Filter data by checking all columns
    const temp = this.tempAssignNewOrganizers.filter((row) => {
      return Object.keys(row).some((key) => 
        row[key]?.toString().toLowerCase().includes(val)
      );
    });
  
    // Update the rows
    this.assignNewOrganizers = temp;
    console.log(temp)
    // Reset to first page
    if (this.table) {
      this.table.offset = 0;
    }
  }
  public onLimitChange2(limit: any): void {
    this.changePageLimit(limit);
    this.table.limit = this.currentPageLimit;
    this.table.recalculate();
    setTimeout(() => {
      if (this.table.bodyComponent.temp.length <= 0) {
        // TODO[Dmitry Teplov] find a better way.
        // TODO[Dmitry Teplov] test with server-side paging.
        this.table.offset = Math.floor((this.table.rowCount - 1) / this.table.limit);
        // this.table.offset = 0;
      }
    });
  }
}
